<div class="dash-details-card">
    <div class="dash-details-card-body pt-4">
        <form [formGroup]="form">
            <div class="transfer-switches">
                <app-switch [group]="form" controlName="received"
                    label="Este fundo foi recebido de outro administrador (entrada)">
                </app-switch>
            </div>

            <section *ngIf="form.controls.received.value">
                <h3>Dados do administrador anterior</h3>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form" controlName="transfer_date"
                            mask="00/00/0000" label="Data de transferência"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form" controlName="assembly_date"
                            mask="00/00/0000" label="Data assembleia"
                            placeholder="dd/mm/aaaa">
                        </app-masked-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <app-masked-input [group]="form"
                            controlName="last_company_document" documentType="cnpj"
                            label="CNPJ" placeholder="00.000.000/0000-00">
                        </app-masked-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="last_company_name"
                            label="Razão social">
                        </app-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="last_company_contact"
                            label="Nome do administrador">
                        </app-input>
                    </div>
                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="last_company_email"
                            type="email" label="E-mail">
                        </app-input>
                    </div>
                    <div class="col-4 col-lg-2">
                        <app-select [group]="form"
                            controlName="last_company_telephone_ddi"
                            [items]="DDIOptions" label="DDI">
                        </app-select>
                    </div>
                    <div class="col-8 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="last_company_telephone_number"
                            label="Telefone"
                            mask="(00) 00000-0000||(00) 0000-0000">
                        </app-masked-input>
                    </div>
                    <div class="col-4 col-lg-2">
                        <app-select [group]="form"
                            controlName="last_company_cellphone_ddi"
                            [items]="DDIOptions" label="DDI">
                        </app-select>
                    </div>
                    <div class="col-8 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="last_company_cellphone_number"
                            label="Celular"
                            mask="(00) 00000-0000||(00) 0000-0000">
                        </app-masked-input>
                    </div>
                </div>
            </section>
        </form>
    </div>
</div>
